exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #c3c9d3;\n  z-index: 1030;\n  transition: all 0.3s;\n}\n.login-page.hiding {\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/login-page/login-page.component.less
// module id = ../../../../../src/app/components/login-page/login-page.component.less
// module chunks = 0